// extracted by mini-css-extract-plugin
export default {"wrap":"ShowMore_wrap__awQmX","btn":"ShowMore_btn__F4cNe"};